<template>
  <div>
  <md-popup
      id="publicFooter"
      class="footer"
      v-model="showFooter"
      :has-mask="false"
      position="bottom"
  >
    <div
        class="tab"
        :class="{ active: activeIndex === index }"
        v-for="(item, index) in tabs"
        :key="index"
        @click="goPath(item.path, index)"
    >
      <img
          class="img-icon"
          v-if="item.path !== '/publish'"
          :src="activeIndex === index ? item.activeImg : item.img"
      />
      <div v-if="(item.path === '/contacts' && (userInfo.msg_sys_count || userInfo.msg_count) > 0)" class="msg-dot" />
      <img class="refresh"
           :class="{ rotate: isRefresh }" v-if="isRefresh && item.path === '/home'"
           :src="require('./assets/refresh.png')"/>
      <span v-if="!isRefresh && item.path === '/home'">{{ item.name }}</span>

      <span v-if="item.path !== '/publish' && item.path !== '/home'">
      <div class="new-message-count" v-if="item.path === '/contacts' && messageCount > 0">{{ messageCount }}</div>
        {{ item.name }}</span>
    </div>
    <!-- <input id="uploadInput" hidden type="file" @change="afterChange" /> -->
  </md-popup>
  <!-- <AppSkeleton v-if="activeIndex === 4 && isShowSkeleton"/> -->
  <!-- <HomeSkeleton v-if="activeIndex === 0 && isShowSkeleton"/>
  <HotSkeleton v-if="activeIndex === 1 && isShowSkeleton"/>
  <CommunitySkeleton v-if="activeIndex === 2 && isShowSkeleton"/>
  <MineSkeleton v-if="activeIndex === 5 && isShowSkeleton"/>
  <MsgSkeleton v-if="activeIndex === 3 && isShowSkeleton"/> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import AppSkeleton from './components/appSkeleton.vue';
// import HomeSkeleton from './components/homeSkeleton.vue';
// import HotSkeleton from './components/hotSkeleton.vue';
// import CommunitySkeleton from './components/communitySkeleton.vue';
// import MineSkeleton from './components/mineSkeleton.vue';
// import MsgSkeleton from './components/msgSkeleton.vue';
import { Dialog } from 'mand-mobile';

export default {
  name: 'PublicFooter',
  data () {
    return {
      showFooter: false,
      activeIndex: 0,
      fileObj: null,
      isRefresh: false,
      messageCount: 0
    };
  },
  components: {
    // AppSkeleton,
    // HomeSkeleton,
    // HotSkeleton,
    // CommunitySkeleton,
    // MineSkeleton,
    // MsgSkeleton
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapState('publicStore', ['isShowSkeleton']),
    ...mapState('message', ['sessions', 'muteList', 'unreadNewFriend', 'unreadCommentNotice']),
    isWhite () {
      return ['Mine', 'Community'].includes(this.$route.name);
    },
    uploadIconUrl () {
      return this.isWhite ? require('./assets/mineUploadIcon.png') : require('./assets/uploadIcon.png');
    },
    tabs () {
      return [
        {
          // name: this.$t('footerHome'),
          name: '首頁',
          imgName: 'home',
          path: '/home',
          img: require('./assets/home.png'),
          activeImg: require('./assets/home-active.png')
        },
        {
          // name: this.$t('footerHot'),
          name: '電影',
          imgName: 'hot',
          path: '/hot',
          img: require('./assets/hot.png'),
          activeImg: require('./assets/hot-active.png')
        },
        {
          name: '社區',
          imgName: 'community',
          path: '/community',
          img: require('./assets/community.png'),
          activeImg: require('./assets/community-active.png')
        },
        {
          name: this.$t('message'),
          path: '/contacts',
          imgName: 'contacts',
          img: require('./assets/contacts.png'),
          activeImg: require('./assets/contacts-active.png')
        },
        {
          name: '應用',
          imgName: 'app',
          path: '/apps',
          img: require('./assets/app.png'),
          activeImg: require('./assets/app-active.png')
        },
        {
          name: '黑料',
          imgName: 'app',
          path: '/black',
          img: require('./assets/black.png'),
          activeImg: require('./assets/black-active.png')
        },
        {
          name: 'AI',
          imgName: 'ai',
          path: '/ai',
          img: require('./assets/ai.png'),
          activeImg: require('./assets/ai-active.png')
        },
        {
          name: this.$t('footerMine'),
          imgName: 'mine',
          path: '/mine',
          img: require('./assets/mine.png'),
          activeImg: require('./assets/mine-active.png')
        }
      ];
    }
  },
  watch: {
    multeList () {
      this.computeMessageNumber();
    },
    sessions: {
      handler () {
        this.computeMessageNumber();
      },
      immediate: true
    },
    unreadCommentNotice () {
      this.computeMessageNumber();
    },
    unreadNewFriend () {
      this.computeMessageNumber();
    },
    $route: {
      handler (val) {
        if (['Home', 'Hot', 'Community', 'Apps', 'Mine', 'friends', 'Contacts', 'Ai', 'BlackMaterial'].includes(val.name)) {
          this.showFooter = true;
        } else {
          this.showFooter = false;
        }
        const index = this.tabs.findIndex(item => item.path === val.path);
        if (index !== -1) {
          this.activeIndex = index;
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('home', ['upload']),
    ...mapMutations('home', ['setPublishVideoInfo', 'setPublishVideoStatus']),
    ...mapMutations('publicStore', ['setLoadingShowFlag']),
    computeMessageNumber () {
      const number = this.sessions.reduce((p, c) => {
        if (this.muteList.findIndex(item => c.to === item.account) === -1) {
          return p + c.unread;
        }

        return p;
      }, 0);

      this.messageCount = number + this.unreadNewFriend + this.unreadCommentNotice
      ;
    },
    goPath (path, index) {
      // if (path === '/upload') {
      //   document.getElementById('uploadInput').click();
      //   return;
      // }
      /*      if (this.$route.name === 'Home' && path === '/home') {
        this.isRefresh = true;
        setTimeout(() => {
          this.isRefresh = false;
        }, 1000);
        this.$bus.$emit('afterChangeLanguage', { isOnlyHomeShortVideo: true });

        this.setLoadingShowFlag(true);
        setTimeout(() => {
          this.setLoadingShowFlag(false);
        }, 500);
      } */
      if (path === '/ai' && !this.isTourist()) return;
      this.activeIndex = index;
      if (this.$route.path === path) return;
      this.$router.push(path);
    },
    async afterChange () {
      this.$router.push({ path: '/publish' });
      // this.$router.push({ path: '/publish' });
      // const file = document.getElementById('uploadInput').files[0];
      // const res = await this.upload({ file });
      // if (res.result === 200000) {
      // this.setPublishVideoInfo(res.data.info);
      // }
      // this.setPublishVideoStatus(1);
    },
    //  检测游客账号
    isTourist () {
      if (this.userInfo.is_tourist === 1) {
        Dialog.confirm({
          title: '确认',
          content: '游客账号先绑定手机号及密码?',
          confirmText: '确定',
          onConfirm: () => {
            this.$router.push('/touristBind');
          }
        });
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  /deep/ .md-popup-box {
    display: flex;
    height: 78px;
    background: #161616;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.0645214);
    backdrop-filter: blur(27.1828px);

    .tab {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      position: relative;
      .msg-dot {
        height: 8px;
        width: 8px;
        //padding: 0 5px;
        display: flex;
        top: 10px;
        right: 15px;
        transform: translateX(50%);
        position: absolute;
        align-items: center;
        border-radius: 50%;
        justify-content: center;
        font-family: 'PingFang SC';
        background: #E63427;
        font-weight: 500;
        font-size: 6px;
        color: #FFFFFF;
      }
      span {
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        text-transform: capitalize;
        color: rgba(255, 255, 255, 0.6);
        position: relative;
      }

      &.active {
        span {
          font-family: 'PingFang SC';
          font-weight: 500;
          color: #FFF;
        }
      }

      .upload-btn {
        width: 36px;
        height: 28px;
      }
      .img-icon {
        width: 24px;
        height: 24px;
        margin-bottom: 5px;
      }
      .refresh {
        width: 22px;
        height: 22px;

        &.rotate {
          animation: rotate 1s ease-in-out infinite;
        }

        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
}

.new-message-count {
  height: 16px;
  min-width: 16px;
  padding: 0 5px;
  display: flex;
  top: -10px;
  right: 0;
  transform: translateX(50%);
  position: absolute;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
  font-family: 'PingFang SC';
  background: #E63427;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
}

.is-white {
  /deep/ .md-popup-box {
    background: #FFF;

    .tab {
      span {
        color: rgba(22, 22, 22, 0.6);
      }

      &.active {
        span {
          color: #161616;
        }
      }
    }
  }

}
</style>
